import Chip from '@components/Chip';
import styled from '@emotion/styled';
import { GiftBoxType } from '@models/gift';
import { Dispatch, SetStateAction } from 'react';

interface Props {
    type: GiftBoxType;
    setType: Dispatch<SetStateAction<GiftBoxType>>;
}

function GiftBoxChips({ type, setType }:Props) {
  return (
        <Container>
            <Chip.Container variant='outline'>
                <Chip isSelected={type === 'RECEIVED'}
                      onClick={() => setType(GiftBoxType.RECEIVED)}>
                    받은 선물
                </Chip>
                <Chip isSelected={type === 'SENT'}
                      onClick={() => setType(GiftBoxType.SENT)}>
                    보낸 선물
                </Chip>
            </Chip.Container>
        </Container>
  );
}

const Container = styled.div`
    padding: 16px 20px
`;

export default GiftBoxChips;
